module.exports = __webpack_public_path__ + "img/arrow_below.6bcc3e5e.png";